export default function AdminFooter() {
  return (
    <footer className="mt-12 py-8 border-t border-primary/10 bg-white/50 backdrop-blur-sm">
      <div className="max-w-7xl mx-auto px-4 text-center">
        <p className="text-sm text-muted-foreground">
          © 2025 SnuggleCrafters.com. All rights reserved. Made with ❤️ by{' '}
          <a 
            href="https://VibeCaaS.com" 
            target="_blank" 
            rel="noopener noreferrer"
            className="bg-gradient-to-r from-purple-600 to-teal-600 bg-clip-text text-transparent hover:from-purple-700 hover:to-teal-700 transition-all duration-200 font-medium"
          >
            VibeCaaS.com
          </a>
        </p>
      </div>
    </footer>
  );
}